import React, { useEffect, useState } from "react";

export default function MailboxForm({
  mailbox,
  tenants = [],
  onSubmit,
  onCancel,
}) {
  const [formData, setFormData] = useState({
    number: "",
    tenantId: "",
    hasMail: false,
  });

  // Prefill when editing
  useEffect(() => {
    if (mailbox) {
      setFormData({
        number: mailbox.number || "",
        tenantId: mailbox.tenant?.id || "",
        hasMail: mailbox.hasMail || false,
      });
    } else {
      setFormData({
        number: "",
        tenantId: "",
        hasMail: false,
      });
    }
  }, [mailbox]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (typeof onSubmit !== "function") {
      console.error("MailboxForm: onSubmit is missing or invalid");
      return;
    }

    onSubmit({
      number: formData.number.trim(),
      tenantId: formData.tenantId ? Number(formData.tenantId) : null,
      hasMail: formData.hasMail,
    });
  };

  return (
    <form onSubmit={handleSubmit} style={{ marginTop: "1rem" }}>
      <input
        name="number"
        placeholder="Mailbox number"
        value={formData.number}
        onChange={handleChange}
      />

      <select
        name="tenantId"
        value={formData.tenantId}
        onChange={handleChange}
        style={{ marginLeft: "1rem" }}
      >
        <option value="">-- No Tenant --</option>

        {tenants.map((t) => (
          <option key={t.id} value={t.id}>
            {t.name} ({t.email})
          </option>
        ))}
      </select>

      <label style={{ marginLeft: "1rem" }}>
        <input
          type="checkbox"
          name="hasMail"
          checked={formData.hasMail}
          onChange={handleChange}
        />
        Has Mail
      </label>

      <div style={{ marginTop: "0.5rem" }}>
        <button type="submit">
          {mailbox ? "Update" : "Add"}
        </button>

        <button
          type="button"
          onClick={onCancel}
          style={{ marginLeft: "0.5rem" }}
        >
          Cancel
        </button>
      </div>
    </form>
  );
}